/**
 * One-off fetch of a container (or master) detail through the query cache —
 * the master picker needs the chosen master's effective config right away.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { QueryClient } from '@tanstack/react-query';

import { api } from '@/services/api';

import type { DropGenContainerDetail } from '../drop-generator.types';
import { dropGeneratorKeys } from '../useDropGenerator';

export function fetchContainerDetail(queryClient: QueryClient, id: string) {
  return queryClient.fetchQuery({
    queryKey: dropGeneratorKeys.container(id),
    queryFn: async () => {
      const res = await api.get<{ data: DropGenContainerDetail }>(`/drop-generator/containers/${id}`);
      return res.data.data;
    },
    staleTime: 0,
  });
}
